module.exports = __webpack_public_path__ + "static/media/vamole-icon-like.723519d3.png";